/**
 * Created by cd01 on 2017/12/22.
 */
{
    angular.module('interfaceModule')
        .controller('CheckRechargeTransidModalController',CheckRechargeTransidModalController);
    CheckRechargeTransidModalController.$inject = ['$scope',"$state",'$stateParams','request.order','alertControl','md5','requestHandler','utils.constant','request.login'];
    function CheckRechargeTransidModalController($scope,$state,$stateParams,orderRequest,alertControl,md5,requestHandler,constant,loginRequest){
        let vm=this;
        $scope.vm=vm;
        let collect={
            'activate':activate,
            'paytypeChose' :paytypeChose,
            'checkTransid': checkTransid,
            'paytype' : '1',
            'transid' : null,
            'waitingPage' : false

        };

        vm.collect=collect;
        activate();

        function activate(){
            console.log('QruserModalController',$scope.userId);
        }

        function paytypeChose(){

        }


        function checkTransid(){
            console.log('bg',$('.bg'));
            $('.bg').css('display','inline-block');
            // collect.waitingPage = true;
            console.log('支付平台',typeof collect.paytype);
            console.log('充值单号',collect.transid);
            if (!collect.transid){
                $('.bg').css('display','none');
                let alert=alertControl.show('',
                    '请输入您充值的商户(订)单号',
                    [{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                        }
                    }]
                );
                return false;
            }
            let _userid = collect.transid.substring(0,11);
            console.log('充值用户',_userid);
            if (collect.transid.length > 17){
                if(!(/^1[34578]\d{9}$/.test(_userid))){
                    // alert("手机号码有误");   这里可以把输入的是订单支付的单号而不是充值的单号排除了。
                    $('.bg').css('display','none');
                    let alert=alertControl.show('',
                        '输入的商户单号有错',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                    return false;
                }else{
                    //
                    let _data = [{
                        userid : _userid,
                        transid: collect.transid,
                        paytype: collect.paytype
                    }];
                    let paramsStr = "checkRechargeTransid=" + JSON.stringify(_data);
                    requestHandler.simpleRequest(constant.action.checkRechargeTransid, paramsStr).then(
                        function (responce){
                            $('.bg').css('display','none');
                            console.log('返回值',responce);
                            if (responce.data[0].result == 1){
                                let alert = alertControl.show('',
                                    '这个用户订单号检测通过并且余额已更新，请到个人中心查看余额',
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                            $scope.$close();
                                        }
                                    }]
                                )
                            }else{
                                let alert = alertControl.show('',
                                    responce.data[0].msg,
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                )
                            }
                        },
                        function (fallData){
                            $('.bg').css('display','none');
                            let alert = alertControl.show('',
                                "网络出错，请重试！",
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            )
                        }
                    )
                }

            }else{
                $('.bg').css('display','none');
                let alert = alertControl.show('',
                    '输入的商户单号有错。如还有疑问，请联系客服！',
                    [{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                        }
                    }]
                )
            }
        }
    }
}

